import * as React from 'react';
import Icon from 'components/Icon';
import { Link } from 'react-router';

export interface iModalDialogProps {
  linkText?: string;
  to?: string;
  onClick?: (e?: React.MouseEvent<HTMLElement>) => boolean | undefined | void;
  newTab?: boolean;
  title: string;
  message?: string;
  // icon className from icons.css
  icon?: string;
  'data-testid'?: string;
  disabled?: boolean;
}

export default function ModalDialog(props: iModalDialogProps) {
  const [open, setOpen] = React.useState(true);
  // destructuring only this prop to optimize useCallback updates
  const { onClick } = props;

  const close = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      let response: boolean | undefined | void = true;
      if (onClick) {
        response = onClick(event);
      }

      if (response !== false) {
        setOpen(false);
      } else {
        event.preventDefault();
      }
    },
    [onClick]
  );

  return (
    open && (
      <div
        className="relative z-[101]"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
        data-testid={props['data-testid']}
      >
        <div className="fixed inset-0 bg-gray-10050 transition-opacity" aria-hidden="true"></div>
        <div className="fixed inset-0 z-[102] w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-sm sm:p-6">
              <div>
                {props.icon && (
                  <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-teal">
                    <Icon className={`${props.icon} size-8 bg-white`} />
                  </div>
                )}
                <div className="mt-3 text-center sm:mt-5">
                  <h3 className="text-base font-semibold capitalize text-gray-900" id="modal-title">
                    {props.title}
                  </h3>
                  <div className="mt-2">
                    <p className="text-sm text-gray-700">{props.message}</p>
                  </div>
                </div>
              </div>
              {props.linkText && (
                <div className="mt-5 sm:mt-6">
                  {props.to ? (
                    <Link
                      to={props.to}
                      onClick={props.disabled ? (e) => e.preventDefault() : close}
                      target={props.newTab ? '_blank' : undefined}
                      aria-disabled={props.disabled}
                      className={`inline-flex w-full select-none justify-center rounded-md bg-teal px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-teal-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal ${
                        props.disabled ? 'pointer-events-none cursor-not-allowed opacity-50' : ''
                      }`}
                    >
                      {props.linkText}
                    </Link>
                  ) : (
                    <button
                      onClick={close}
                      type="button"
                      disabled={props.disabled}
                      aria-disabled={props.disabled}
                      className={`inline-flex w-full select-none justify-center rounded-md bg-teal px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-teal-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal ${
                        props.disabled ? 'pointer-events-none cursor-not-allowed opacity-50' : ''
                      }`}
                    >
                      {props.linkText}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  );
}
